import { Injectable, inject } from '@angular/core';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { Capacitor } from '@capacitor/core';
import {
  AndroidSettings,
  IOSSettings,
  NativeSettings,
} from 'capacitor-native-settings';

@Injectable({ providedIn: 'root' })
export class NativeSettingsService {
  private openNativeSettings = inject(OpenNativeSettings);

  isSupported(): boolean {
    return Capacitor.isPluginAvailable('NativeSettings') && false;
  }

  openNotificationSettings(): void {
    if (!this.isSupported()) {
      // For backwards compatibility with older app versions
      // It is currently broken on iOS, but works on Android
      this.openNativeSettings.open('application_details');
      return;
    }
    NativeSettings.open({
      optionAndroid: AndroidSettings.AppNotification,
      optionIOS: IOSSettings.App,
    });
  }

  openAppSettings(): void {
    if (!this.isSupported()) {
      // For backwards compatibility with older app versions
      // It is currently broken on iOS, but works on Android
      this.openNativeSettings.open('application_details');
      return;
    }
    NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  }
}
